import { SEPARATOR_STRING } from '/@/shared/api/utils';

export const Separator = () => {
    return <>{SEPARATOR_STRING}</>;
};
